module.exports = __webpack_public_path__ + "img/DTYLX_pt.728eb6a6.png";